import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useSalesPageMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemAppointments */
  const menuItemAppointments = {
    id: "appointments",
    title: t("AppModuleNames.Provider.Appointments"),
    url: baseRouteMakerForSuperAdmin(routes.SALES_PAGE_APPOINTMENTS),
  };
  tempMenuGroup.push(menuItemAppointments);
  /* menuItemAppointments */

  /* menuItemConfiguration */
  const menuItemConfiguration = {
    id: "configuration",
    title: t("Modules.Configuration.configuration"),
    url: baseRouteMakerForSuperAdmin(routes.SALES_PAGE_CONFIGURATION),
  };
  tempMenuGroup.push(menuItemConfiguration);
  /* menuItemConfiguration */

  return tempMenuGroup;
};
